import {Layers, RockBottomLayers, SimpleStageLayer} from "../../../view/RockBottomLayers";
import {gsap, TimelineLite} from "gsap";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpinePlayer} from "../../../../core/utils/SpinePlayer";

export class BigWinView extends PIXI.Container {

    private _layer: SimpleStageLayer | undefined;
    private _overlay: PIXI.Graphics;
    private _bigWinAnims: SpinePlayer[] = [];

    constructor() {
        super();
        this.init();
        this.onResize();
    }

    public getLevelAnimation(level: number, duration: number, isEndLevel: boolean): TimelineLite {
        const tl = gsap.timeline();
        tl.add(() => {
            this._overlay.visible = true;
            if (level > 0) {
                this._bigWinAnims[level - 1].stop();
            }
        });
        tl.add(this.playPngSeq(level));

        tl.to(this, {duration: 0.1});
        return tl;
    }

    public playEnding(endLevel: number): void {
        this._bigWinAnims[endLevel].stop();
        this._overlay.visible = false;
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.BIG_WIN);
        this.createOverlay();
        this.createBigWinAnims();
        this._layer?.addChild(this);
    }

    private playPngSeq(level: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._bigWinAnims[level].play({
                name: "animation"
            });
        });

        return tl;
    }

    private createBigWinAnims(): void {
        const wrapper: PIXI.Container = new PIXI.Container();
        wrapper.name = "bigWinAnims";

        for (let i: number = 0; i < 5; i++) {
            const spineName: string = "bigwin_L" + (i + 1),
                spineAnim: SpinePlayer = new SpinePlayer(spineName);

            spineAnim.position.set(360);
            spineAnim.name = spineName;
            this._bigWinAnims.push(spineAnim);
            wrapper.addChild(spineAnim);
        }

        this.addChild(wrapper);
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics();
        this._overlay.visible = false;
        this.setOverlayProps();
        this.addChild(this._overlay);
    }

    private onResize(): void {
        this.setOverlayProps();
    }

    private setOverlayProps(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._overlay.clear();
        this._overlay.beginFill(0x000000, 0.75);
        this._overlay.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._overlay.endFill();
    }
}